import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { AppInterface } from '../../../interfaces/app.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';
import { OwnershipType } from 'src/app/core/enums/ownership-type.enum';

export class AppOwnerCriteria implements SearchCriteria {
  getMatchScore(_app: AppInterface, _query: string): number {
    if (_app.ownerShipType ===  OwnershipType.COMMUNITY) {
        return 0;
    } 
    return _app.appOwner?.displayName.toLowerCase().includes(_query) ? 1 : 0;
  }

  getRelevanceFieldWeightAndMatchScore(_app: AppInterface, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.OWNER,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.OWNER,
      matchScore: this.getMatchScore(_app, _query),
    }
  }
}